import script from "./EPatientCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EPatientCard.vue?vue&type=script&setup=true&lang=ts"

import "./EPatientCard.vue?vue&type=style&index=0&id=9f3204fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f3204fc"]])

export default __exports__